import React, { useState, useEffect } from 'react';
import { Select, Input, Popup,Dropdown } from 'semantic-ui-react';
import api from "../../api";
import "./integration.css"
import ConfirmDialog from "../Modal/ConfirmDialog";
import { use } from 'react';
// Modal Component
const ServiceTitanModal = ({
  show,
  onclose,
  parsedData,
  type,
  title = 'Map ServiceTitan Fields',
  data_mappings = [],
  maxWidth = 800,
}) => {
  const serviceTitanOptions = [
    { key: 'name', value: 'name', text: 'Name*' },
    { key: 'phone', value: 'phone', text: 'Phone*' },
    { key: 'email', value: 'email', text: 'Email*' },
    { key: 'street', value: 'street', text: 'Street*' },
    { key: 'city', value: 'city', text: 'City*' },
    { key: 'state', value: 'state', text: 'State*' },
    { key: 'zip', value: 'zip', text: 'Zip*' },
    { key: 'country', value: 'country', text: 'Country*' },
    { key: 'start', value: 'start', text: 'Start' },
    { key: 'priority', value: 'priority', text: 'Priority' },
    { key: 'customerType', value: 'customerType', text: 'Customer Type' },
    { key: 'source', value: 'source', text: 'Source*' },
    // { key: 'isSendConfirmationEmail', value: 'isSendConfirmationEmail', text: 'Confirmation Email' },
    { key: 'summary', value: 'summary', text: 'Summary*' }
  ];
  const required_fields = ['name', 'phone', 'street', 'city', 'state', 'zip', 'country', 'summary','source'];
  const single_params = [ 'phone', 'city', 'state', 'zip', 'country', 'source','start','email'];
const extra_fields=['Recoding url','Call transcript','Call summary','Call parsed data','From number'];
  const [mappings, setMappings] = useState([]);
  const [stparamsList, setSTparamsList] = useState([]);
  const [steditparamsList, seteditSTparamsList] = useState([]);
  const [botparsedData, setParsedData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(null);
  const [opendoc, setopendoc] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [tempSTparam, setTempSTparam] = useState('');
  const [tempParsedData, setTempParsedData] = useState([]);
  const [tempConstant, setTempConstant] = useState('');
  // const [deleteBranchAlert, setDeleteBranchAlert] = useState(false)
  const [loading, setLoading] = useState(false);
  const [backupMappings, setBackupMappings] = useState([]);
  const [editmap,setEditmap]=useState([]);

  // Initialize mappings, stparamsList, and botparsedData
  useEffect(() => {
    setSaveError(null);
    setSaveSuccess(null);
    // Normalize data_mappings to ensure parsedfield is always an array
    const normalizedMappings = data_mappings.map((mapping) => ({
      ...mapping,
      parsedfield: Array.isArray(mapping.parsedfield) ? mapping.parsedfield : [mapping.parsedfield].filter(Boolean),
      constant: mapping.constant || '',
      isConstant: mapping.isConstant || Boolean(mapping.constant)
    }));

    // Filter out serviceTitanOptions already in normalized mappings
    const mappedSTParams = normalizedMappings.map((m) => m.stcol);
    const filteredSTParams = serviceTitanOptions.filter((option) => !mappedSTParams.includes(option.value));
    setSTparamsList(filteredSTParams);

    // Initialize botparsedData from parsedData prop
    let new_parsedData=parsedData;
    let pars_keys= new_parsedData.map(user => user.key);
    if(type=='call'){
      for(let j=0;j<extra_fields.length;j++){
            if(!pars_keys.includes(extra_fields[j])){
              new_parsedData.push({key:extra_fields[j],index:parsedData.length+j});
            }
            
          }
    }else{
      if(!pars_keys.includes('Chat transcript')){
              new_parsedData.push({key:'Chat transcript',index:parsedData.length});
        }
        if(!pars_keys.includes('Chat parsed data')){
              new_parsedData.push({key:'Chat parsed data',index:parsedData.length+1});
        }
      
      
    }
    
    //const mappedParsedKeys = normalizedMappings.flatMap((m) => m.parsedfield || []);
    //const filteredParsedData = new_parsedData.filter((item) => !mappedParsedKeys.includes(item.key));
    const filteredParsedData = new_parsedData;
    setParsedData(filteredParsedData);

    // Set normalized mappings
    setMappings(normalizedMappings);
    setSaveError(null);
    setSaveSuccess(null);
    setTempConstant("");
  }, [parsedData, data_mappings]);
  //keeep backup
  useEffect(() => {
    if(editingIndex == null) {
      setBackupMappings(mappings);
    }
  }, [mappings]);

  // Cleanup timeout on unmount
  useEffect(() => {
    let timeoutId;
    if (saveSuccess) {
      timeoutId = setTimeout(() => {
        onclose(1);
        setSaveError(null);
        setSaveSuccess(null);
      }, 4000);
    }
    return () => clearTimeout(timeoutId);
  }, [saveSuccess, onclose]);
  const resetdata = () => {
    //reset all like start
    setTempSTparam('');
    setTempParsedData([]);
    setTempConstant('');
    setEditingIndex(null);
    setSaveError(null);
    setMappings([]); // Restore from backup
    setSTparamsList(serviceTitanOptions.filter((option) => !mappings.some((m) => m.stcol === option.value)));
    setParsedData(parsedData.map((item) => ({ key: item.key }))); // Reset parsedData to original state 
  }
  const toggleDoc = () => {
    setopendoc(!opendoc);
  };
  
  // const deleteBranchName = () => {
  //       setDeleteBranchAlert(false)
  //       setLoading(true)

  // }     

  const editMapping = (index) => {
    const mapping = mappings[index];
    setTempSTparam(mapping.stcol);
    //let fields=getoriginal(mapping.parsedfield)
    setTempParsedData(mapping.parsedfield || []);
    setTempConstant(mapping.constant || '');
    setEditingIndex(index);
    let editMap=mappings.filter((m) => m.stcol == mapping.stcol);
    setEditmap(editMap);
    let newMapping=mappings.filter((m) => m.stcol !== mapping.stcol)
    setMappings(newMapping);
    setMappings(mappings.filter((_, i) => i !== index));
    const deletedSTParam = serviceTitanOptions.find((option) => option.value === mapping.stcol);
    console.log(deletedSTParam,'deletedSTParam');
    if (deletedSTParam) {
      seteditSTparamsList([deletedSTParam]);
    }
  };

  const saveMapping = () => {
    if (tempSTparam) {
      // Validate that at least one of parsedfield or constant is provided
      if (tempParsedData.length === 0 && !tempConstant) {
        setSaveError('Please select at least one parsed data field or provide a constant value.');
        return;
      }
      if ((typeof tempParsedData[0]!=='undefined' && tempParsedData.length==1 && tempParsedData[0].length==0) && !tempConstant) {
        setSaveError('Please select at least one parsed data field or provide a constant value.');
        return;
      }

      const newMapping = {
        stcol: tempSTparam,
        parsedfield: tempParsedData,
        constant: tempConstant,
        isConstant: Boolean(tempConstant)
      };

      // if (editingIndex !== null) {
      //   // Update existing mapping
      //   const updatedMappings = [...mappings];
      //   updatedMappings[editingIndex] = newMapping;
      //   setMappings(updatedMappings);
      //   // Restore previous stcol to stparamsList
      //   const prevSTParam = serviceTitanOptions.find((option) => option.value === mappings[editingIndex].stcol);
      //   if (prevSTParam && !updatedMappings.some((m) => m.stcol === prevSTParam.value)) {
      //     setSTparamsList([...stparamsList, prevSTParam]);
      //   }
      //   // Restore previous parsed fields
      //   if (mappings[editingIndex].parsedfield.length > 0) {
      //     setParsedData([...botparsedData, ...mappings[editingIndex].parsedfield.map((field) => ({ key: field }))]);
      //   }
      // } else {
        // Add new mapping
        setMappings([...mappings, newMapping]);
     // }

      // Update stparamsList and botparsedData
      setSTparamsList(stparamsList.filter((item) => item.value !== tempSTparam));
      // if (tempParsedData.length > 0) {
      //   setParsedData(botparsedData.filter((item) => !tempParsedData.includes(item.key)));
      // }

      // Reset form for new mapping
      setTempSTparam('');
      setTempParsedData([]);
      setTempConstant('');
      setEditingIndex(null);
      setSaveError(null);
    }
  };

  const deleteMapping = (index) => {
    //cancelEdit();
    const mapping = mappings[index];
    setMappings(mappings.filter((_, i) => i !== index));
    const deletedSTParam = serviceTitanOptions.find((option) => option.value === mapping.stcol);
    if (deletedSTParam) {
      setSTparamsList([...stparamsList, deletedSTParam]);
    }
    // if (mapping.parsedfield.length > 0) {
    //   setParsedData([...botparsedData, ...mapping.parsedfield.map((field) => ({ key: field }))]);
    // }
    setSaveError(null);
  };

  const handleSave = async () => {
    const unmappedRequired = required_fields.filter(
      (field) => !mappings.some((m) => m.stcol === field)
    );
    if (unmappedRequired.length > 0) {
      setSaveError(`Please map all required fields: ${unmappedRequired.join(', ')}`);
      return;
    }

    setIsSaving(true);
    setSaveError(null);
    setSaveSuccess(null);
    try {
      setLoading(true);
      const params = {
        type,
        mappings,
      };
      const resp = await api.servicetitan.saveMapping(params);
      if (resp.status) {
        setSaveSuccess('Mappings saved successfully!');
         setLoading(false);
      } else {
         setLoading(false);
        throw new Error('Save operation failed');
        
      }
    } catch (error) {
       setLoading(false);
      setSaveError('Error saving mappings: ' + error.message);
    } finally {
       setLoading(false);
      setIsSaving(false);
    }
  };

  // Convert parsedData to options for Semantic UI Select
  const parsedDataOptions = botparsedData.map((item, index) => ({
    key: index,
    value: item.key,
    text: item.key,
  }));

  // Calculate progress for required fields
  const mappedRequiredCount = mappings.filter((m) => required_fields.includes(m.stcol)).length;
  const progressPercentage = (mappedRequiredCount / required_fields.length) * 100;
const cancelEdit=()=>{
    setTempSTparam('');
    setTempParsedData([]);
    setTempConstant('');
    setEditingIndex(null);
    setSaveError(null); 
     setMappings([...mappings,...editmap]); // Restore the mapping from backup

    //setMappings(backupMappings); // Restore from backup
}
const getoriginal=(fields)=>{
  console.log(botparsedData,"botparsedData");
  if (fields && fields.length > 0) {
      fields = fields.map((field) => {
        const formattedInput = field.replace(/_/g, ' ');
        const match = fields.find(field => field.key === formattedInput);
        return match ? match.key : formattedInput;
    });
    return fields;
  }
  return fields;
}
  return (
    <div
      className={show ? 'modal completedchats fade show' : 'modal completedchats fade'}
      data-backdrop="static"
      tabIndex="-1"
      role="dialog"
      data-keyboard="false"
      aria-labelledby="staticBackdrop"
      aria-hidden="true"
      style={{ display: show ? 'block' : 'none', zIndex: 999 }}
      id="stmappingbox"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth }}
      >
        <div className="modal-content">
          {/* Documentation Modal */}
          <div
            className={opendoc ? "modal fade show" : "modal fade"}
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="staticBackdrop"
            aria-hidden="true"
            style={{ display: opendoc ? "block" : "none" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={toggleDoc}
                  style={{ zIndex: '9 !important' }}
                   id="docclosebtn"
                >
                  X
                </button>
                <div className="modal-body stdocmodal">
                  {loading && <div className='ui loading form'></div>}
                  <h3 style={{fontWeight:'600',marginLeft: '-12px'}}>ServiceTitan Booking API Parameters</h3>
                  <h4>Contact Information</h4>
                  <ul>
                    <li>
                      <strong>name:</strong>
                      <span className="description">The name of the customer or the booking.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>Phone:</strong>
                      <span className="description">The contact phone number for the booking or customer.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>Email:</strong>
                      <span className="description">The email address for the booking or customer.</span>
                      <span className="required-status required-recommended">Required: Recommended</span>
                    </li>
                  </ul>
                  <h4>Address Information</h4>
                  <ul>
                    <li>
                      <strong>street:</strong>
                      <span className="description">The street address for the service location.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>city:</strong>
                      <span className="description">The city of the service location.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>state:</strong>
                      <span className="description">The state of the service location.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>zip:</strong>
                      <span className="description">The postal code (ZIP code) of the service location.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>country:</strong>
                      <span className="description">The country of the service location.</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                  </ul>
                  <h4>Booking Details</h4>
                  <ul>
                    <li>
                      <strong>Summary:</strong>
                      <span className="description">Summary or description of booking</span>
                      <span className="required-status required-yes">Required: Yes</span>
                    </li>
                    <li>
                      <strong>start:</strong>
                      <span className="description">The requested start time or date for the service.</span>
                      <span className="required-status required-no">Required: No</span>
                    </li>
                    <li>
                      <strong>priority:</strong>
                      <span className="description">The priority level of the booking (Low, Normal, High, Urgent).</span>
                      <span className="required-status required-no">Required: No, often has a default</span>
                    </li>
                    <li>
                      <strong>customerType:</strong>
                      <span className="description">The type of customer (residential, commercial).</span>
                      <span className="required-status required-no">Required: No, often has a default</span>
                    </li>
                     <li>
                      <strong>source:</strong>
                      <span className="description">Source of the booking.</span>
                      <span className="required-status required-yes">Required:yes</span>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* Main Modal Header */}
          <div className={`modal-header ${title.replace(/\s/g, '')}`}>
            <div className="row w-100">
              <div className="col-md-8">
                <h5 className="modal-title">{title}&nbsp;{type=='call' ? 'for AI Call':'for Chat'}</h5>
              </div>
              <div className="col-md-4 text-right">
                <button
                  className="btn linear-gradient yr-submitbtn btn-sm pull-right"
                  onClick={toggleDoc}
                  style={{marginTop:'30px',marginRight:'-10px'}}
                >
                 Booking Fields Info
                </button>
                <button
                  type="button"
                  className="close linear-gradient"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={onclose}
                 id="stmapv2close"
                >
                  X
                </button>
              </div>
            </div>
          </div>
          {/* Modal Body */}
          <div className="modal-body parsedatap" style={{ paddingTop: '10px' }}>
            <div className="container-fluid">
              {/* Progress Indicator */}
              <div className='row'>
                <div className='col-md-12'>
                  {/* Messages */}
              {saveError && (
                <div className="alert alert-danger mt-3" role="alert">
                  {saveError}
                </div>
              )}
              {saveSuccess && (
                <div className="alert alert-success mt-3" role="alert">
                  {saveSuccess}
                </div>
              )}
                </div>

              </div>
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted small">
                    Required Fields: {mappedRequiredCount}/{required_fields.length}
                  </span>
                  <span className="text-muted small">
                    {progressPercentage.toFixed(0)}% Complete
                  </span>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar mapprogress"
                    role="progressbar"
                    style={{ width: `${progressPercentage}%` }}
                    aria-valuenow={progressPercentage}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              {/* Mapping Form */}
              {(editingIndex !== null || mappings.length < serviceTitanOptions.length) && (
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <Popup
                          content="Choose a ServiceTitan field to map"
                          trigger={
                            <Select
                              placeholder="Select Booking Field"
                              options={editingIndex!=null ? steditparamsList  : stparamsList}
                              value={tempSTparam}
                              onChange={(e, { value }) => {
                                setTempSTparam(value);
                              }}
                              search
                              fluid
                            />
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        {single_params.includes(tempSTparam) ? <Popup
                          content="Select one parsed field"
                          trigger={
                           
                            <Select
                              placeholder="Select Parsed Field"
                              options={parsedDataOptions}
                              value={tempParsedData[0] || ''}
                              onChange={(e, { value }) => setTempParsedData([value])}
                              search
                              fluid
                              clearable
                            
                      />
                          }
                        /> : <Popup
                          content="Select one or more parsed fields"
                          trigger={
                           
                            <Select
                              placeholder="Select Parsed Fields"
                              options={parsedDataOptions}
                              value={tempParsedData}
                              onChange={(e, { value }) => setTempParsedData(value)}
                              search
                              fluid
                              multiple
                              clearable
                      />
                          }
                        />}
                      </div>
                      <div className="col-md-4">
                        <Popup
                          content="Enter a fixed value or fallback value(if empty or N/A)"
                          trigger={
                            <Input
                              placeholder="Default/Fallback Value"
                              value={tempConstant}
                              onChange={(e) => setTempConstant(e.target.value)}
                              fluid
                            />
                          }
                        />
                      </div>
                      </div>
                      <div className='row'>
                      <div className="col-md-12" style={{marginTop:'10px'}}>
                        {editingIndex!=null && <button
                          onClick={cancelEdit}  
                          className="mapbtn yr-cancelbtn1 linear-gradient-cancel yr-cnclbtn btn-sm yr-btn-small"
                          style={{marginLeft:'67%'}}
                        >
                        Cancel
                        </button>} 
                        <button
                          onClick={saveMapping}
                          className="mapbtn btn linear-gradient yr-submitbtn btn-sm pull-right"
                          disabled={!tempSTparam || (tempParsedData.length === 0 && !tempConstant)}
                        >
                        {editingIndex!=null ? 'Update' : 'Map'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Mappings List */}
              {mappings.length > 0 && (
                <div style={{ height: 'auto', overflow: 'auto', maxHeight: '350px' }}>
                  {mappings.map((mapping, index) => (
                    <div
                      key={index}
                      className="card mb-2"
                    >
                      <div className="card-body d-flex justify-content-between align-items-center">
                        <div>
                          <span className="font-weight-bold">
                            {mapping.stcol}
                            <sup className="text-danger">{required_fields.includes(mapping.stcol) ? '*' : ''}</sup>
                          </span>
                          <span className="text-muted mx-2">→</span>
                          <span>
                            {mapping.parsedfield.length > 0 ? mapping.parsedfield.join(', ') : 'N/A'}
                            {mapping.constant ? ` (Default/Fallback: ${mapping.constant})` : ''}
                          </span>
                        </div>
                        <div className="btn-group">
                          {editingIndex === null && <span
                            onClick={editingIndex == null ? () => editMapping(index):''}
                            className={editingIndex == null ? "mapicon" : "mapicondisabled"}
                            style={{marginTop:'20px'}}
                            disabled={editingIndex !== null}
                          >
                            <i className="fa fa-edit"></i>
                          </span>}
                           {editingIndex === null &&<span
                            onClick={() => deleteMapping(index)}
                            className="mapicon red"
                          >
                            <i  style={{color:'#FF0000 !important'}} className="fa fa-trash maptrash red"></i>
                          </span>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
            </div>
          </div>
          {/* Modal Footer */}
          <div className="modal-footer">
            {/* <button
              onClick={resetdata}
              className="yr-cancelbtn1 linear-gradient-cancel yr-cnclbtn btn-sm yr-btn-small"
              style={{marginRight:'12px'}}
              disabled={isSaving || editingIndex !== null}
            >
              Reset
            </button> */}
            <button
              onClick={handleSave}
              className="btn linear-gradient yr-submitbtn btn-sm pull-right"
              style={{marginRight:'12px'}}
              disabled={isSaving || editingIndex !== null}
            >
              {isSaving ? 'Saving...' : 'Save Mappings'}
            </button>
          </div>
          {/* {deleteBranchAlert && <ConfirmDialog
                                      show={deleteBranchAlert}
                                      toggleModal={deleteBranchName}
                                      closeAction={deleteModalClose}
                                      title="Confirm your action"
                                      message={"Do you want to delete this branch?"}
                                  />} */}
        </div>
      </div>
    </div>
  );
};

export default ServiceTitanModal;